
export const TRAFFIC_STATUS_CONV_TABLE = {
    "-3" : "",
    "-2" : "SULJETTU | CLOSED",
    "-1" : "N/A",
    "0" : "1  min",
    "1" : "2  min",
    "2" : "3+ min"
}

export const TRAFFIC_STATUS_CSS_TABLE = {
    "-2" : "status-closed",
    "-1" : "status-offline",
    "0" : "status-low",
    "1" : "status-mid",
    "2" : "status-high"
}

export const TRAFFIC_STATUS_COLOR_TABLE = {
    "-3" : "#f20",
    "-2" : "#f20",
    "-1" : "#aaa",
    "0" : "#0f9",
    "1" : "orange",
    "2" : "#f54"
}

const LUNCH_LINE_OPEN_TIMES = {
    "koti1-vasen": [10.5, 12.25], 
    "koti1-oikea": [10.5, 12.25],
    "koti2-vasen": [10.5, 13.5],
    "koti2-oikea": [10.5, 13.5],
    "koti2-vege" : [10.5, 13.5]
}


export const LUNCH_LINE_DISPLAY_NAMES = {
    "koti1-vasen": "1A", 
    "koti1-oikea": "1B",
    "koti2-vasen": "2A",
    "koti2-oikea": "2B",
    "koti2-vege" : "VEGE"
}


export function isOpenDuring(line : string, time : Number) : boolean {
    return LUNCH_LINE_OPEN_TIMES[line][0] < time && 
           LUNCH_LINE_OPEN_TIMES[line][1] > time;
} 